import { Controller } from "@hotwired/stimulus";
import { DirectUpload } from "@rails/activestorage";

export default class extends Controller {
  static targets = ["input", "list"];
  static values = { fieldName: String };

  connect() {
    this.noteIndex = 0;
    this.pendingUploadsCount = 0;
    this.setSubmitButtonsDisabled(false);
  }

  upload() {
    const files = Array.from(this.inputTarget.files || []);
    if (files.length === 0) return;

    this.pendingUploadsCount += files.length;
    this.setSubmitButtonsDisabled(true);
    this.inputTarget.disabled = true;

    Promise.all(files.map((file) => this.uploadFile(file)))
      .catch((error) => {
        console.error(error);
        alert("Unable to upload one or more photos.");
      })
      .finally(() => {
        this.inputTarget.value = "";
        this.pendingUploadsCount = Math.max(
          this.pendingUploadsCount - files.length,
          0,
        );
        this.setSubmitButtonsDisabled(this.pendingUploadsCount > 0);
        this.inputTarget.disabled = false;
      });
  }

  uploadFile(file) {
    return new Promise((resolve, reject) => {
      const upload = new DirectUpload(
        file,
        "/rails/active_storage/direct_uploads",
        this.inputTarget,
      );

      upload.create((error, blob) => {
        if (error) {
          reject(error);
        } else {
          this.appendUploadedPhoto(file, blob);
          resolve(blob);
        }
      });
    });
  }

  appendUploadedPhoto(file, blob) {
    const noteId = this.noteIndex;
    this.noteIndex += 1;

    const wrapper = document.createElement("div");
    wrapper.className = "rounded border p-2";

    const image = document.createElement("img");
    image.src = URL.createObjectURL(file);
    image.alt = "Photo preview";
    image.className = "h-28 w-full rounded object-cover";

    const hiddenImage = document.createElement("input");
    hiddenImage.type = "hidden";
    hiddenImage.name = `${this.fieldNameValue}[${noteId}][image]`;
    hiddenImage.value = blob.signed_id;

    const textarea = document.createElement("textarea");
    textarea.name = `${this.fieldNameValue}[${noteId}][body]`;
    textarea.className = "form-control mt-2 w-full";
    textarea.rows = 2;
    textarea.placeholder = "Optional note";

    const removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.className = "mt-2 text-sm text-red-600";
    removeButton.textContent = "Remove";
    removeButton.addEventListener("click", () => wrapper.remove());

    wrapper.appendChild(image);
    wrapper.appendChild(hiddenImage);
    wrapper.appendChild(textarea);
    wrapper.appendChild(removeButton);

    this.listTarget.appendChild(wrapper);
  }

  setSubmitButtonsDisabled(disabled) {
    const form = this.element.closest("form");
    if (!form) return;

    form
      .querySelectorAll("button[type='submit'], input[type='submit']")
      .forEach((button) => {
        button.disabled = disabled;
      });
  }
}
